export default () => {
  return {
    activeTab: '',
    initTabs: function() {
      this.activeTab = 0
      if(window.location.hash) {
        this.activeTab = window.location.hash.replace('#', '')
      }
    },
    openTab: function(slug) {
      setTimeout(() => {
        if(`${window.location.hash}` === `#${slug}`) {
          this.activeTab = slug
        }
      }, 500)
    },
  }
}
